module.exports = __webpack_public_path__ + "img/paimai.3cf3995.png";